export default {
    "en": {
        "All_Parents_Signin_With_Kakao": "Sign in with Kakao",
        "All_Parents_Signin_With_Google": "Sign in with Google",
        "All_Parents_Signin_With_Email": "Sign in with Email",
        "All_Parents_Signin_Or": "or",
        "All_Parents_Signin_Title1": "Welcome to Todo English!",
        "All_Parents_Signin_Title1_Description1": "Enter your account information to sign in.",
        "All_Parents_Signin_Title1_Description1_email": "Enter your account information to sign in.",
        "All_Parents_Signin_Title1_InputBox1": "Email Address",
        "All_Parents_Signin_Title1_InputBox2": "Password",
        "All_Parents_Signin_Title1_Button1": "Sign in",
        "All_Parents_Signin_Title1_Button2": "Forgot password?",
        "All_Parents_Signin_Title1_Button3": "Sign up",
        "All_Parents_Signin_Title1_ErrorMessage1": "This account does not exist",
        "All_Parents_Signin_Title1_ErrorMessage2": "Wrong password",
        "All_Parents_Signin_Title1_ErrorMessage3": "Unauthorized Access.\nForward to Todo English Website",
        "All_Parents_Signin_Title1_ErrorMessage4": "The period has expired.\nForward to Todo English Website",
        "All_Parents_Signup_Title1": "Welcome to Todo English!",
        "All_Parents_Signup_Title1_Description1": "Sign Up",
        "All_Parents_Signup_Title1_InputBox1": "Email Address",
        "All_Parents_Signup_Title1_InputBox2": "Password",
        "All_Parents_Signup_Title1_InputBox3": "Retype Password",
        "All_Parents_Signup_Title1_Button1": "Sign up",
        "All_Parents_Signup_Title1_ErrorMessage1": "Password is too short!",
        "All_Parents_Signup_Title1_ErrorMessage2": "Passwords do not match!",
        "All_Parents_SignupAgreement_Title1": "Welcome to Todo English!",
        "All_Parents_SignupAgreement_Title1_Description1": "Sign Up",
        "All_Parents_SignupAgreement_Title1_Description2": "I confirm that I am an adult and not a child under the age of 13. (Required)",
        "All_Parents_SignupAgreement_Title1_Description3": "I agree to register my email address and phone number to receive educational reports on my child's progress as well as marketing and promotional materials. (Optional)",
        "All_Parents_SignupAgreement_Title1_Description4": "If you consent to Todo English's {Terms of Service} and {collection and use of personal information}, please press OK.",
        "All_Parents_SignupAgreement_Title1_Button1": "OK",
        "All_Parents_FindPassword_Title1": "Forgot password?",
        "All_Parents_FindPassword_Title1_Description1": "Enter your email address",
        "All_Parents_FindPassword_Title1_InputBox1": "Email Address",
        "All_Parents_FindPassword_Title1_Button1": "OK",
        "All_Parents_FindPassword_Title1_ErrorMessage1": "This account does not exist",
        "All_Parents_FindPassword_Title1_SystemMessage1": "We sent an email to the address above.<br>Please check your inbox!",
        "All_Parents_FindPassword_Title1_SystemMessage2": "Unauthorized Access. Forward to Todo English Website",
        "All_Parents_FindPassword_Title1_Button2": "OK",
        "All_Parents_Myinfo_Title1": "My Purchase Summary",
        "All_Parents_Myinfo_Title1_label1": "Last purchase date",
        "All_Parents_Myinfo_Title1_label2": "Valid for",
        "All_Parents_Myinfo_Title1_label3": "Subscription plan",
        "All_Parents_Myinfo_Title2": "Learner",
        "All_Parents_Myinfo_Title2_label1": "Level",
        "All_Parents_Error_CA00": "Internal Server Error",
        "All_Parents_Error_CA01": "This account does not exist",
        "All_Parents_Error_CA03": "Migration Failed",
        "All_Parents_Error_CA04": "Email address is Duplicated",
        "All_Parents_Error_CA06": "Wrong password",
        "All_Parents_Error_CA07": "Password not found",
        "All_Parents_Error_CA08": "Password already exist",
        "All_Parents_Error_CA09": "migration failed (school)",
        "All_Parents_Error_CA10": "email address is invalid",
        "All_Parents_Error_CA11": "black list email domain",
        "All_Parents_Error_CA12": "Token not found",
        "All_Parents_Error_CA13": "Token expired",
        "All_Parents_Error_CA14": "SupportKey duplicated",
        "All_Parents_Error_CA15": "Kakao account already exist",
        "All_Parents_Error_CA16": "Google account already exist",
        "All_Parents_Error_CA17": "Email account already exist",
        "All_Parents_Error_CA18": "Other service account already exist",
        "Coupon_Error_EC00" : "Internal error",
        "Coupon_Error_EC01" : "Coupon code not valid",
        "Coupon_Error_EC02" : "Coupon code already used",
        "Coupon_Error_EC03" : "Account not found",
        "Coupon_Error_EC04" : "Coupon already registered by the same user",
        "Coupon_Error_EC05" : "Coupon not found",
        "Coupon_Error_EC06" : "Product not found",
        "Coupon_Error_EC07" : "Identical group of coupon already used by the user",
        "Coupon_Error_EC08" : "Bad Request",
        "Coupon_Error_EC09" : "Coupon code conflict",
        "Coupon_Error_EC10" : "Coupon expired",
        "Coupon_Error_EC11" : "Coupon restricted by rules",
        "Coupon_Error_EC12" : "Max count exceeded",
        "Coupon_Error_EC13" : "Coupon revoked",
        "Coupon_Error_EC14" : "Coupon refunded",
        "Coupon_Error_EC15" : "Coupon code not found",
        "Coupon_Error_EC16" : "Coupon code not valid",
        "Coupon_not_input" : "Write coupon code"
    },
    "ko": {
        "Coupon_Title1":"토도영어 쿠폰 이용 안내",
        "Coupon_Title2": "로그인 / 회원가입",
        "Coupon_Title3": "쿠폰 코드 입력",
        "Coupon_Title4": "등록 완료 & 플레이",
        "Signin_Title1":"로그인",
        "Signin_InputBox1":"이메일",
        "Signin_InputBox2":"비밀번호",
        "Signin_Button1":"로그인",
        "Signin_Textlink1":"가입하기",
        "Signin_Textlink2":"비밀번호 찾기",
        "Signin_ErrorMessage1":"존재하지 않는 계정입니다.",
        "Signin_ErrorMessage2":"비밀번호가 틀렸습니다.",
        "email_InputBox_ErrorMessage1":"이메일 주소에 '@'를 포함해 주세요.<br>'{input}'에 '@'가 없습니다.",
        "email_InputBox_ErrorMessage2":"'@' 앞 부분에 '{input}' 기호가 포함되면 안됩니다.",
        "Signup_Title1":"회원가입",
        "Signup_InputBox1":"이메일",
        "Signup_InputBox2":"비밀번호",
        "Signup_InputBox3":"비밀번호 확인",
        "Signup_Button1":"가입하기",
        "Signup_ErrorMessage1":"비밀번호가 일치하지 않습니다.",
        "Signup_ErrorMessage2":"이메일 계정이 이미 있습니다. ",
        "Signup_ErrorMessage3":"다른 서비스 계정이 이미 있습니다. ",
        "Signup_agree__Title1":"회원가입",
        "Signup_agree__Title2":"본인은 성인이며, 13세 이하의 아동이 아님을 확인합니다.(필수)",
        "Signup_agree__Title3":"Email 및 휴대전화 번호를 등록하여 자녀의 학습 리포트와 할인 정보를 받아보겠습니다.(선택)",
        "Signup_agree__Title4":"토도영어의 {이용약관} 및 {개인정보 수집 및 이용}에 동의하시면 확인을 눌러주세요.",
        "Signup_agree_Button1":"확인",
        "FindPassword_Title1":"비밀번호 찾기",
        "FindPassword_InputBox1":"이메일",
        "FindPassword_Button1":"확인",
        "FindPassword_Error_Popup1":"존재하지 않는 계정입니다.",
        "FindPassword_Ok_Popup1":"비밀번호 변경을 위한 이메일을 발송하였습니다.<br>메일함을 확인해주세요.",
        "FindPassword_Ok_Popup_Button1":"확인",
        "Signout_Message":"로그아웃 되었습니다.",
        "Signout_Button":"확인",
        "Coupon_Error_EC00" : "내부 시스템 오류가 발생 했습니다. (Code - EC00)<br>공식 채널로 문의해 주세요.",
        "Coupon_Error_EC01" : "유효하지 않은 코드입니다.<br>코드를 다시 확인해 주세요.",
        "Coupon_Error_EC02" : "이미 등록된 코드입니다.",
        "Coupon_Error_EC03" : "계정을 찾을 수 없습니다. (Code - EC03)<br>공식 채널로 문의해 주세요.",
        "Coupon_Error_EC04" : "이미 등록하신 코드입니다.",
        "Coupon_Error_EC05" : "쿠폰을 찾을 수 없습니다. (Code - EC05)<br>공식 채널로 문의해 주세요.",
        "Coupon_Error_EC06" : "제품을 찾을 수 없습니다. (Code - EC06)<br>공식 채널로 문의해 주세요.",
        "Coupon_Error_EC07" : "이미 등록하신 코드와 중복 사용할 수 없는 코드입니다.",
        "Coupon_Error_EC08" : "문제가 발행 했습니다. (Code - EC08)<br>공식 채널로 문의해 주세요.",
        "Coupon_Error_EC09" : "Coupon code conflict (Code - EC09)",
        "Coupon_Error_EC10" : "등록 기간이 만료된 코드 입니다.",
        "Coupon_Error_EC11" : "라이센스(체험,멤버십,월구독) 이용 대상 조건에 의해 사용이 제한된 코드 입니다.<br>코드 사용 조건을 다시 확인해 주세요.",
        "Coupon_Error_EC12" : "쿠폰 등록 최대 개수 초과로 사용할 수 없는 코드입니다.",
        "Coupon_Error_EC13" : "사용할 수 없는 코드입니다. (Code - EC13)<br>공식 채널로 문의해 주세요.",
        "Coupon_Error_EC14" : "사용할 수 없는 코드입니다. (Code - EC14)<br>공식 채널로 문의해 주세요.",
        "Coupon_Error_EC15" : "Coupon code not found (Code - EC15)",
        "Coupon_Error_EC16" : "국가 사용 제한 코드로 사용할 수 없는 코드입니다.<br>공식 채널로 문의해 주세요.",
        "Coupon_not_input" : "코드를 입력해 주세요.",
        "All_Parents_Signin_With_Kakao": "카카오로 시작하기",
        "All_Parents_Signin_With_Google": "구글로 시작하기",
        "All_Parents_Signin_With_Email": "이메일로 시작하기",
        "All_Parents_Signin_Or": "또는",
        "All_Parents_Signin_Title1": "토도영어 쿠폰 이용 안내",
        "All_Parents_Signin_Title1_Description1": "토도영어에 등록한 방법으로 로그인 하세요.",
        "All_Parents_Signin_Title1_Description1_email": "가입하신 이메일로 로그인 하세요.",
        "All_Parents_Signin_Title1_InputBox1": "이메일",
        "All_Parents_Signin_Title1_InputBox2": "비밀번호",
        "All_Parents_Signin_Title1_Button1": "로그인",
        "All_Parents_Signin_Title1_Button2": "비밀번호 찾기",
        "All_Parents_Signin_Title1_Button3": "가입하기",
        "All_Parents_Signin_Title1_ErrorMessage1": "존재하지 않는 계정입니다.",
        "All_Parents_Signin_Title1_ErrorMessage2": "비밀번호가 틀렸습니다.",
        "All_Parents_Signin_Title1_ErrorMessage3": "할인 대상자로 확인 되지 않아\n토도영어 홈페이지로 연결 됩니다.",
        "All_Parents_Signin_Title1_ErrorMessage4": "아쉽게도 할인 기간이 만료 되어\n토도영어 홈페이지로 연결 됩니다.",
        "All_Parents_Signup_Title1": "토도영어에 오신 것을 환영합니다!",
        "All_Parents_Signup_Title1_Description1": "회원 가입",
        "All_Parents_Signup_Title1_InputBox1": "이메일",
        "All_Parents_Signup_Title1_InputBox2": "비밀번호",
        "All_Parents_Signup_Title1_InputBox3": "비밀번호 확인",
        "All_Parents_Signup_Title1_Button1": "가입하기",
        "All_Parents_Signup_Title1_ErrorMessage1": "Password is too short!",
        "All_Parents_Signup_Title1_ErrorMessage2": "비밀번호가 일치하지 않습니다.",
        "All_Parents_SignupAgreement_Title1": "토도영어에 오신 것을 환영합니다!",
        "All_Parents_SignupAgreement_Title1_Description1": "회원 가입",
        "All_Parents_SignupAgreement_Title1_Description2": "본인은 성인이며, 13세 이하의 아동이 아님을 확인합니다.(필수)",
        "All_Parents_SignupAgreement_Title1_Description3": "Email 및 휴대전화 번호를 등록하여 자녀의 학습 리포트와 할인 정보를 받아 보겠습니다. (선택)", 
        "All_Parents_SignupAgreement_Title1_Description4": "토도영어의 {이용약관} 및 {개인정보 수집 및 이용}에 동의하시면 확인을 눌러주세요.",
        "All_Parents_SignupAgreement_Title1_Button1": "확인",
        "All_Parents_FindPassword_Title1": "비밀번호 찾기",
        "All_Parents_FindPassword_Title1_Description1": "이메일 주소를 입력하세요.",
        "All_Parents_FindPassword_Title1_InputBox1": "이메일",
        "All_Parents_FindPassword_Title1_Button1": "확인",
        "All_Parents_FindPassword_Title1_ErrorMessage1": "존재하지 않는 계정입니다.",
        "All_Parents_FindPassword_Title1_SystemMessage1": "비밀번호 변경을 위한 이메일을 발송하였습니다.<br>메일함을 확인해주세요.",
        "All_Parents_FindPassword_Title1_SystemMessage2": "접근권한이 없습니다. 토도영어 홈페이지로 돌아갑니다.",
        "All_Parents_FindPassword_Title1_Button2": "확인",
        "All_Parents_Myinfo_Title1": "구매 내역",
        "All_Parents_Myinfo_Title1_label1": "마지막 구매 날짜",
        "All_Parents_Myinfo_Title1_label2": "유효기간",
        "All_Parents_Myinfo_Title1_label3": "구독상품",
        "All_Parents_Myinfo_Title2": "사용자",
        "All_Parents_Myinfo_Title2_label1": "레벨",
        "All_Parents_Error_CA00": "Internal Server Error",
        "All_Parents_Error_CA01": "존재하지 않는 계정입니다.",
        "All_Parents_Error_CA03": "Migration Failed",
        "All_Parents_Error_CA04": "Email address is Duplicated",
        "All_Parents_Error_CA06": "비밀번호가 틀렸습니다.",
        "All_Parents_Error_CA07": "Password not found",
        "All_Parents_Error_CA08": "Password already exist",
        "All_Parents_Error_CA09": "migration failed (school)",
        "All_Parents_Error_CA10": "email address is invalid",
        "All_Parents_Error_CA11": "black list email domain",
        "All_Parents_Error_CA12": "Token not found",
        "All_Parents_Error_CA13": "Token expired",
        "All_Parents_Error_CA14": "SupportKey duplicated",
        "All_Parents_Error_CA15": "카카오 계정이 이미 있습니다.",
        "All_Parents_Error_CA16": "구글 계정이 이미 있습니다.",
        "All_Parents_Error_CA17": "이메일 계정이 이미 있습니다.",
        "All_Parents_Error_CA18": "다른 서비스 계정이 이미 있습니다.",
        
    },
    "cn": {
        "Coupon_Title1":"都都英语激活码使用指南",
        "Coupon_Title2": "注册或登录",
        "Coupon_Title3": "输入激活码",
        "Coupon_Title4": "使用激活码并下载应用",
        "Signin_Title1":"登录",
        "Signin_InputBox1":"输入电子邮箱",
        "Signin_InputBox2":"输入密码",
        "Signin_Button1":"登录",
        "Signin_Textlink1":"注册",
        "Signin_Textlink2":"忘记密码",
        "Signin_ErrorMessage1":"用户不存在",
        "Signin_ErrorMessage2":"密码输入错误",
        "email_InputBox_ErrorMessage1":"请在邮箱地址中包含‘@'符号。<br>'{input}'中缺少'@'符号。",
        "email_InputBox_ErrorMessage2":"'@' 前边不能有 '{input}' 符号。",
        "Signup_Title1":"注册",
        "Signup_InputBox1":"输入电子邮箱",
        "Signup_InputBox2":"输入密码",
        "Signup_InputBox3":"再次输入密码",
        "Signup_Button1":"注册",
        "Signup_ErrorMessage1":"两次输入密码不同",
        "Signup_ErrorMessage2":"该邮箱已被其他账号使用",
        "Signup_ErrorMessage3":"该邮箱已被其它登录方式使用注册",
        "Signup_agree__Title1":"注册",
        "Signup_agree__Title2":"确认本人为成年人，不是13岁以下的儿童。(必须)",
        "Signup_agree__Title3":"我想要通过邮箱接收孩子的学习报告及促销活动信息。(选择)",
        "Signup_agree__Title4":"请查看都都英语的{使用条款}及{个人隐私条}款并同意。",
        "Signup_agree_Button1":"确定",
        "FindPassword_Title1":"忘记密码",
        "FindPassword_InputBox1":"输入您的邮箱账号",
        "FindPassword_Button1":"确定",
        "FindPassword_Error_Popup1":"该账号不存在",
        "FindPassword_Ok_Popup1":"密码修改邮件已发送到您的邮箱。<br>请前往邮箱确认。",
        "FindPassword_Ok_Popup_Button1":"确定",
        "Signout_Message":"已退出",
        "Signout_Button":"确定",
        "Coupon_Error_EC00" : "系统错误！ 请重启软件或设备，需要帮助请联系客服QQ 2179916770 (Code - EC00)",
        "Coupon_Error_EC01" : "输入的激活码有误，请确认后再次激活",
        "Coupon_Error_EC02" : "该激活码已被使用。如有疑问请联系官方客服。",
        "Coupon_Error_EC03" : "找不到账号，请确认账号信息。如有疑问请联系客服QQ 2179916770 (Code - EC03)",
        "Coupon_Error_EC04" : "您已经使用过该激活码。",
        "Coupon_Error_EC05" : "找不到激活码，请确认号码。如有疑问请联系客服QQ 2179916770 (Code - EC05)",
        "Coupon_Error_EC06" : "Product not found",
        "Coupon_Error_EC07" : "该激活码不能与已使用过的码重叠使用",
        "Coupon_Error_EC08" : "发生错误！请重启软件或设备，需要帮助请联系客服QQ 2179916770 (Code - EC08)",
        "Coupon_Error_EC09" : "Coupon code conflict",
        "Coupon_Error_EC10" : "激活码已过期。",
        "Coupon_Error_EC11" : "该激活码有可使用用户限制（体验用户/普通会员/连续订阅会员）。请确认后再使用。",
        "Coupon_Error_EC12" : "该码已经超出了可使用次数限制。",
        "Coupon_Error_EC13" : "无法使用的激活码。",
        "Coupon_Error_EC14" : "无法使用的激活码。",
        "Coupon_Error_EC15" : "Coupon code not found",
        "Coupon_Error_EC16" : "该激活码有可使用地区限制，需要帮助请联系客服QQ 2179916770 (Code - EC16)",
        "Coupon_not_input" : "请输入激活码",
        "All_Parents_Signin_With_Kakao": "Sign in with Kakao",
        "All_Parents_Signin_With_Google": "Sign in with Google",
        "All_Parents_Signin_With_Email": "Sign in with Email",
        "All_Parents_Signin_Or": "or",
        "All_Parents_Signin_Title1": "都都英语激活码使用指南",
        "All_Parents_Signin_Title1_Description1": "输入您的帐户信息以登录。",
        "All_Parents_Signin_Title1_Description1_email": "输入您的帐户信息以登录。",
        "All_Parents_Signin_Title1_InputBox1": "输入电子邮箱",
        "All_Parents_Signin_Title1_InputBox2": "输入密码",
        "All_Parents_Signin_Title1_Button1": "登录",
        "All_Parents_Signin_Title1_Button2": "忘记密码",
        "All_Parents_Signin_Title1_Button3": "注册",
        "All_Parents_Signin_Title1_ErrorMessage1": "用户不存在",
        "All_Parents_Signin_Title1_ErrorMessage2": "密码输入错误",
        "All_Parents_Signin_Title1_ErrorMessage3": "Unauthorized Access.\nForward to Todo English Website",
        "All_Parents_Signin_Title1_ErrorMessage4": "The period has expired.\nForward to Todo English Website",
        "All_Parents_Signup_Title1": "欢迎来到都都数学！",
        "All_Parents_Signup_Title1_Description1": "注册",
        "All_Parents_Signup_Title1_InputBox1": "输入电子邮箱",
        "All_Parents_Signup_Title1_InputBox2": "输入密码",
        "All_Parents_Signup_Title1_InputBox3": "再次输入密码",
        "All_Parents_Signup_Title1_Button1": "注册",
        "All_Parents_Signup_Title1_ErrorMessage1": "Password is too short!",
        "All_Parents_Signup_Title1_ErrorMessage2": "两次输入密码不同",
        "All_Parents_SignupAgreement_Title1": "欢迎来到都都数学！",
        "All_Parents_SignupAgreement_Title1_Description1": "注册",
        "All_Parents_SignupAgreement_Title1_Description2": "确认本人为成年人，不是13岁以下的儿童。（必须）", 
        "All_Parents_SignupAgreement_Title1_Description3": "我想要通过邮箱接收孩子的学习报告及促销活动信息。（选择）",
        "All_Parents_SignupAgreement_Title1_Description4": "请查看都都英语的{使用条款}及{个人隐私条}款并同意。",
        "All_Parents_SignupAgreement_Title1_Button1": "确定",
        "All_Parents_FindPassword_Title1": "忘记密码",
        "All_Parents_FindPassword_Title1_Description1": "输入您的电子邮件",
        "All_Parents_FindPassword_Title1_InputBox1": "输入您的邮箱账号",
        "All_Parents_FindPassword_Title1_Button1": "确定",
        "All_Parents_FindPassword_Title1_ErrorMessage1": "该账号不存在",
        "All_Parents_FindPassword_Title1_SystemMessage1": "密码修改邮件已发送到您的邮箱。<br>请前往邮箱确认。",
        "All_Parents_FindPassword_Title1_SystemMessage2": "",
        "All_Parents_FindPassword_Title1_Button2": "确定",
        "All_Parents_Myinfo_Title1": "我的订阅情况",
        "All_Parents_Myinfo_Title1_label1": "最近的购买",
        "All_Parents_Myinfo_Title1_label2": "有效期",
        "All_Parents_Myinfo_Title1_label3": "",
        "All_Parents_Myinfo_Title2": "学习者",
        "All_Parents_Myinfo_Title2_label1": "水平",
        "All_Parents_Error_CA00": "Internal Server Error",
        "All_Parents_Error_CA01": "用户不存在",
        "All_Parents_Error_CA03": "Migration Failed",
        "All_Parents_Error_CA04": "Email address is Duplicated",
        "All_Parents_Error_CA06": "密码输入错误",
        "All_Parents_Error_CA07": "Password not found",
        "All_Parents_Error_CA08": "Password already exist",
        "All_Parents_Error_CA09": "migration failed (school)",
        "All_Parents_Error_CA10": "email address is invalid",
        "All_Parents_Error_CA11": "black list email domain",
        "All_Parents_Error_CA12": "Token not found",
        "All_Parents_Error_CA13": "Token expired",
        "All_Parents_Error_CA14": "SupportKey duplicated",
        "All_Parents_Error_CA15": "该邮箱已被其它登录方式使用注册",
        "All_Parents_Error_CA16": "该邮箱已被其它登录方式使用注册t",
        "All_Parents_Error_CA17": "该邮箱已被其他账号使用",
        "All_Parents_Error_CA18": "该邮箱已被其它登录方式使用注册",
    },
    "ja": {
        "All_Parents_Signin_With_Kakao": "Sign in with Kakao",
        "All_Parents_Signin_With_Google": "Sign in with Google",
        "All_Parents_Signin_With_Email": "Sign in with Email",
        "All_Parents_Signin_Or": "or",
        "All_Parents_Signin_Title1": "トドさんすうへようこそ！",
        "All_Parents_Signin_Title1_Description1": "アカウント情報を入力してログインします。",
        "All_Parents_Signin_Title1_Description1_email": "アカウント情報を入力してログインします。",
        "All_Parents_Signin_Title1_InputBox1": "メールアドレス入力",
        "All_Parents_Signin_Title1_InputBox2": "パスワード入力",
        "All_Parents_Signin_Title1_Button1": "ログイン",
        "All_Parents_Signin_Title1_Button2": "パスワードを忘れた場合",
        "All_Parents_Signin_Title1_Button3": "登録",
        "All_Parents_Signin_Title1_ErrorMessage1": "存在しないアカウントです。",
        "All_Parents_Signin_Title1_ErrorMessage2": "パスワードが間違っています。",
        "All_Parents_Signin_Title1_ErrorMessage3": "Unauthorized Access.\nForward to Todo English Website",
        "All_Parents_Signin_Title1_ErrorMessage4": "The period has expired.\nForward to Todo English Website",
        "All_Parents_Signup_Title1": "トドさんすうへようこそ！",
        "All_Parents_Signup_Title1_Description1": "会員登録",
        "All_Parents_Signup_Title1_InputBox1": "メールアドレス",
        "All_Parents_Signup_Title1_InputBox2": "パスワード",
        "All_Parents_Signup_Title1_InputBox3": "パスワードを再入力してください",
        "All_Parents_Signup_Title1_Button1": "登録",
        "All_Parents_Signup_Title1_ErrorMessage1": "Password is too short!",
        "All_Parents_Signup_Title1_ErrorMessage2": "Passwords do not match!",
        "All_Parents_SignupAgreement_Title1": "トドさんすうへようこそ！",
        "All_Parents_SignupAgreement_Title1_Description1": "会員登録",
        "All_Parents_SignupAgreement_Title1_Description2": "私は成人で、13歳以下の子どもではないことを確認しました。（必須）",
        "All_Parents_SignupAgreement_Title1_Description3": "メールアドレス、及び携帯電話番号を登録し、子どもの学習レポートとお得なセール情報を受け取ります。（選択）",
        "All_Parents_SignupAgreement_Title1_Description4": "トドさんすうの {利用規約} 及び {個人情報の収集と利用} に同意する場合は、「確認」をタップしてください。",
        "All_Parents_SignupAgreement_Title1_Button1": "確認",
        "All_Parents_FindPassword_Title1": "パスワードを忘れた場合",
        "All_Parents_FindPassword_Title1_Description1": "メールアドレス入力",
        "All_Parents_FindPassword_Title1_InputBox1": "メールアドレス入力",
        "All_Parents_FindPassword_Title1_Button1": "確認",
        "All_Parents_FindPassword_Title1_ErrorMessage1": "存在しないアカウントです。",
        "All_Parents_FindPassword_Title1_SystemMessage1": "上記のメールアドレスにメールを送信しました。<br>受信トレイを確認してください。",
        "All_Parents_FindPassword_Title1_SystemMessage2": "",
        "All_Parents_FindPassword_Title1_Button2": "確認",
        "All_Parents_Myinfo_Title1": "購入内訳",
        "All_Parents_Myinfo_Title1_label1": "最終購入日",
        "All_Parents_Myinfo_Title1_label2": "有効期間",
        "All_Parents_Myinfo_Title1_label3": "",
        "All_Parents_Myinfo_Title2": "ユーザー",
        "All_Parents_Myinfo_Title2_label1": "レベル",
        "All_Parents_Error_CA00": "Internal Server Error",
        "All_Parents_Error_CA01": "存在しないアカウントです。",
        "All_Parents_Error_CA03": "Migration Failed",
        "All_Parents_Error_CA04": "Email address is Duplicated",
        "All_Parents_Error_CA06": "パスワードが間違っています。",
        "All_Parents_Error_CA07": "Password not found",
        "All_Parents_Error_CA08": "Password already exist",
        "All_Parents_Error_CA09": "migration failed (school)",
        "All_Parents_Error_CA10": "email address is invalid",
        "All_Parents_Error_CA11": "black list email domain",
        "All_Parents_Error_CA12": "Token not found",
        "All_Parents_Error_CA13": "Token expired",
        "All_Parents_Error_CA14": "SupportKey duplicated",
        "All_Parents_Error_CA15": "Kakao account already exist",
        "All_Parents_Error_CA16": "Google account already exist",
        "All_Parents_Error_CA17": "Email account already exist",
        "All_Parents_Error_CA18": "Other service account already exist",
    }
}


// WEBPACK FOOTER //
// ./src/text/parent/laptop.js